<div class="modal-header">
    <h4 class="modal-title">Attachment</h4>
</div>
<div class="modal-body p-0">
    <div style="height: 20rem" class="p-2">
        <Input id="contained-button-file" (change)="upload($event,common.CompanyParameterValue.ProofAttachment)"
            name="ProofAttachment" accept=".jpeg,.jpg,.png,.pdf" type="file" #ProofAttachment required
            ngbTooltip="Choose File" style="display: none;" />
        <div class="row g-0" style="place-content: center;" *ngIf="!IsView">
            <div class="col-4 ImageDiv mb-2" style="height: 100px;align-content: center" (click)="ProofAttachment.click()">
                <div>
                    <i class="bi bi-upload"></i>
                    <br />
                    <label>Upload</label>
                </div>
            </div>
            <hr/>
        </div>
        
        <div class="row g-2 mt-3">
            <div class="attachmentThumbTD col-md-3" *ngFor="let attachment of Attachments; let i = index">
                <div class="position-relative">
                    <app-thumbnail-attachment *ngIf="attachment.Url != null && attachment.Url != ''"
                        [attachmentUrl]="attachment.Url">
                    </app-thumbnail-attachment>

                    <button class="btn btn-danger btn-sm position-absolute top-0 end-0 translate-middle"
                        style="border-radius: 50%; width: 20px; height: 20px; padding: 0; z-index: 10;"
                        (click)="remove(i)" *ngIf="!IsView">
                        <i class="bi bi-x" style="font-size: 12px;"></i>
                    </button>
                </div>
            </div>

            <!-- <ul class="list-group">
                <li class="list-group-item" style="display: inherit;"
                    *ngFor="let attachment of Attachments; let i = index">
                    <div class="col-auto d-flex align-items-center">
                        <i class="bi bi-card-image" style="color: var(--primary);"></i>
                    </div>
                    <div class="col d-flex align-items-center">
                        <span><a [href]="attachment.Url" target="_blank">{{attachment.FileName}}</a></span>
                    </div>
                    <div class="col-auto d-flex align-items-center" *ngIf="!IsView">
                        <i class="bi bi-x-circle deleteIcon" (click)="remove(i)"></i>
                    </div>
                </li>
            </ul> -->
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="close()"><i class="bi bi-check"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
            *ngIf="isDisabled"></span>OK</button>
</div>